(() => {
  const form = document.getElementById('ElviraArrepentimientoForm');
  if (!form) return;
  const key = 'olympe-arrepentimiento-reference';
  const success = form.querySelector('[data-withdrawal-success]');
  if (success) {
    try {
      const reference = sessionStorage.getItem(key);
      if (reference) success.textContent = 'Recibimos tu solicitud de arrepentimiento. Tu código de identificación es ' + reference + '. Guardalo para consultar el estado de tu solicitud.';
    } catch {}
    return;
  }
  const field = form.querySelector('[data-withdrawal-reference]');
  if (!field) return;
  field.value += '-' + crypto.getRandomValues(new Uint32Array(1))[0].toString(36).toUpperCase();
  form.addEventListener('submit', () => {
    try { sessionStorage.setItem(key, field.value); } catch {}
  });
})();